import React, { useState } from "react"
import { connect, useSelector } from "react-redux"
import { IMAGES } from "../../constants"
import { useHomePageData } from "../../prismic/staticQueries"

const AwardSection = ({ heading = true, small = false }) => {
  const language = useSelector(state => state.language)
  const { awards_list, awards_heading } = useHomePageData(language)
  return (
    <>
      <section className="">
        <div className="container">
          {heading ?
            <h2 className="text-center" style={{ color: "#156eb6" }}>
              {awards_heading.text}
            </h2>
            : null}
          <div className="row">
            {awards_list.length > 0 && awards_list.map((val, index) => (
              <div className="col-lg-4 text-center" key={index}>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={val.award_link.text}
                >
                  <img
                    style={{ width: small ? 100 : 250, height: 'auto', alignContent: 'center' }}
                    src={val.thumbnail.url}
                    alt={val.award_title.text}
                  />
                </a>
                {small
                  ? <span className="text-bold-md text-dark mb-1" style={{ fontSize: 11 }}>
                    {val.award_title.text}
                  </span>
                  : <>
                    <h2 className="text-md text-bold-md text-dark mb-1">
                      {val.award_title.text}
                    </h2>
                    <p className="mb-1">
                      {val.award_description.text}
                    </p>
                  </>
                }
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}

const mapStateToProps = state => {
  return {
    language: state.language,
  }
}

export default connect(mapStateToProps)(AwardSection)
